const system = {
  'web_root': '/',
  'static_asset': '/static/',
  'starter_code': '/static/starter-code'
}

export { system }



// WEBPACK FOOTER //
// ./src/settings/index.js